<template>
    <div v-if="user">
        <div class="panel panel-success"  >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU SMTP
            </div>
            <div class="panel-body" v-if="user.level === 1" >
                <p v-if="!smtp_id">
                    <a :href="'#/smtp/novo'" class="btn btn-info btn-block">NOVO SMTP</a>
                </p>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: {
        smtp_id: null
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
